var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGewaesser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Gewaesser__Icn/40px/Legende/Gewaesser",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6442337,15 C15.33677,15 16.8144838,15.7897333 18.9250368,17.5358179 L19.878101,18.3486648 L20.8707002,19.2134076 L21.3693348,19.6373609 L21.8332769,20.0210198 C21.9078722,20.0816842 21.981144,20.1407289 22.0531533,20.1981836 L22.4705472,20.5240694 C23.8818165,21.5995508 24.7901272,22 25.7604452,22 C28.1987546,22 30.6012366,20.686918 32.982415,17.9815805 L33.2374604,17.6863918 L34.7625396,18.9802748 C31.9482465,22.2974373 28.9421696,24 25.7604452,24 C24.3934044,24 23.2895159,23.5886815 21.7909707,22.5166301 L21.3515077,22.1921351 L20.8871574,21.8303891 C20.8075023,21.7669221 20.7266682,21.701849 20.644584,21.6351431 L20.1365099,21.2150968 L19.5950249,20.7545677 L18.1870659,19.5300216 L17.6865663,19.1073813 C15.90821,17.6344816 14.7385847,17 13.6442337,17 C12.1446929,17 10.5290658,17.7792259 8.93780864,19.1022683 C8.36173085,19.5812452 7.83156701,20.0966699 7.36173019,20.6115542 L7.05087348,20.9621276 L6.89892324,21.1429624 L6.79332483,21.2754653 L5.20667517,20.0578681 L5.42664141,19.7852738 L5.63266709,19.5448849 C5.70904181,19.4576337 5.79302882,19.3635408 5.88436646,19.2634458 C6.41258693,18.6845801 7.00744997,18.1062548 7.65915472,17.5643983 C9.57584767,15.9707741 11.5886258,15 13.6442337,15 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Gewaesser__Path-Copy-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGewaesser);
export default __webpack_public_path__ + "static/media/Gewaesser.1498d3e6a0b96aaa0e52675396f37eec.svg";
export { ForwardRef as ReactComponent };